import { IconProps } from './IconProps';
export function LockIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11 15C11 15.2652 11.1054 15.5196 11.2929 15.7071C11.4804 15.8946 11.7348 16 12 16C12.2652 16 12.5196 15.8946 12.7071 15.7071C12.8946 15.5196 13 15.2652 13 15C13 14.7348 12.8946 14.4804 12.7071 14.2929C12.5196 14.1054 12.2652 14 12 14C11.7348 14 11.4804 14.1054 11.2929 14.2929C11.1054 14.4804 11 14.7348 11 15Z"
                stroke="#FF1E2D"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 16V19"
                stroke="#FF1E2D"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.5 9.5H19.5C19.5 9.5 20.5 9.5 20.5 10.5V22.5C20.5 22.5 20.5 23.5 19.5 23.5H4.5C4.5 23.5 3.5 23.5 3.5 22.5V10.5C3.5 10.5 3.5 9.5 4.5 9.5Z"
                stroke="#FF1E2D"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.5 6C6.5 4.54131 7.07946 3.14236 8.11091 2.11091C9.14236 1.07946 10.5413 0.5 12 0.5C13.4587 0.5 14.8576 1.07946 15.8891 2.11091C16.9205 3.14236 17.5 4.54131 17.5 6V9.5H6.5V6Z"
                stroke="#FF1E2D"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
